import React from 'react';
import * as Styles from './AiChatFullSreenHandler.styles';
import { useAiChat } from '@/hooks/AiChat';

export const AiChatFullScreenHandler = () => {
  const { handleRenderFullScreenAiChat } = useAiChat();
  return (
    <Styles.Container id="ai-chat-full-screen-container">
      {handleRenderFullScreenAiChat()}
    </Styles.Container>
  );
};

export default AiChatFullScreenHandler;
